/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */

window.addEventListener('DOMContentLoaded', () => {
  function handleChartData(importedDataset) {
    const { chartId, chartTitle, chartType, coloursArray, datasetsArray, labelsArray } =
      importedDataset;
    const chartctx = document.getElementById(chartId);

    function generateChart(ctx, type, labels, datasets, text, axis) {
      const myChart = new Chart(ctx, {
        type,
        data: {
          labels,
          datasets,
        },
        options: {
          indexAxis: axis,
          responsive: true,
          plugins: {
            title: {
              display: true,
              text,
            },
          },
        },
      });
      return myChart;
    }

    if (chartctx) {
      const datasets = [];
      if (chartType === 'pie' || chartType === 'doughnut') {
        const { label, data, borderColor } = datasetsArray[0];
        const datasetObj = { label, data, backgroundColor: coloursArray, borderColor };
        datasets.push(datasetObj);
        generateChart(chartctx, chartType, labelsArray, datasets, chartTitle, 'x');
      }
      if (chartType === 'bar-horizontal' || chartType === 'bar-vertical') {
        datasetsArray.forEach((dataset) => {
          datasets.push(dataset);
        });
        if (chartType === 'bar-horizontal') {
          generateChart(chartctx, 'bar', labelsArray, datasets, chartTitle, 'y');
        } else {
          generateChart(chartctx, 'bar', labelsArray, datasets, chartTitle, 'x');
        }
      }
      if (chartType === 'line-vertical' || chartType === 'line-horizontal') {
        datasetsArray.forEach((dataset) => {
          datasets.push(dataset);
        });
        if (chartType === 'line-horizontal') {
          generateChart(chartctx, 'line', labelsArray, datasets, chartTitle, 'x');
        } else {
          generateChart(chartctx, 'line', labelsArray, datasets, chartTitle, 'y');
        }
      }
    }
  }

  if (chartData.length > 0) {
    chartData.forEach((importedDataset) => {
      handleChartData(importedDataset);
    });
  }
});
